import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
  shadow?: "sm" | "md" | "lg" | "none";
}

const Card: React.FC<CardProps> = ({
  children,
  className = "",
  onClick,
  hover = false,
  shadow = "md",
}) => {
  const shadowStyles = {
    none: "",
    sm: "shadow",
    md: "shadow-md",
    lg: "shadow-lg",
  };

  return (
    <div
      onClick={onClick}
      className={`
        bg-white rounded-xl p-5
        ${shadowStyles[shadow]}
        ${hover ? "hover:shadow-card-hover cursor-pointer transition-shadow duration-200" : ""}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Card;
